import { takeEvery } from 'redux-saga/effects';
import { FILE_UPLOAD_ALL_FILES_UPLOAD_START, FILE_UPLOAD_SINGLE_FILE_UPLOAD_START, FILE_UPLOAD_RETRY_FILES_UPLOAD_START, FILE_UPLOAD_RC_RETRY_FILES_UPLOAD_START, FILE_UPLOAD_RC_ALL_FILES_UPLOAD_START, FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_START } from '../actions';
import { uploadSingleFileSaga, uploadSaga, uploadRCSingleFileSaga, uploadRCSaga } from './upload';
export const fileRootSaga = [
    takeEvery([FILE_UPLOAD_ALL_FILES_UPLOAD_START, FILE_UPLOAD_RETRY_FILES_UPLOAD_START], uploadSaga),
    takeEvery(FILE_UPLOAD_SINGLE_FILE_UPLOAD_START, uploadSingleFileSaga),
    takeEvery([FILE_UPLOAD_RC_ALL_FILES_UPLOAD_START, FILE_UPLOAD_RC_RETRY_FILES_UPLOAD_START], uploadRCSaga),
    takeEvery(FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_START, uploadRCSingleFileSaga)
];
//# sourceMappingURL=fileRootSaga.js.map